import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "app-icon-double-arrow",
  "use": "app-icon-double-arrow-usage",
  "viewBox": "0 0 13 10",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 13 10\" id=\"app-icon-double-arrow\"><path d=\"M1.4 0L.1 1.4l3.2 3.2L0 7.8l1.4 1.4h.1l4.6-4.6L1.5 0h-.1zm6.4 0L6.4 1.4l3.2 3.2-3.2 3.2 1.3 1.4h.1l4.6-4.6L7.8 0z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol